import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import WebFontLoader from 'webfontloader';
import Home from './Home';

WebFontLoader.load({
  google: {
    families: ['Roboto:300,400,500,700', 'Material Icons'],
  },
});

ReactDOM.render(<Home /> , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js